import { render } from "./SelectPerPage.vue?vue&type=template&id=45cc7424&scoped=true"
import script from "./SelectPerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPerPage.vue?vue&type=script&setup=true&lang=js"

import "./SelectPerPage.vue?vue&type=style&index=0&id=45cc7424&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cc7424"],['__file',"src/components/UI/table/SelectPerPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45cc7424"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45cc7424', __exports__)) {
    api.reload('45cc7424', __exports__)
  }
  
  module.hot.accept("./SelectPerPage.vue?vue&type=template&id=45cc7424&scoped=true", () => {
    api.rerender('45cc7424', render)
  })

}


export default __exports__